<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="modal-header" id="modalTitle">
          <slot name="header">
            <h5>Lista de correos</h5>
            <div class="box-salir">
              <a @click="close"></a>
              <button
                type="button"
                class="btn-close"
                @click="close"
                aria-label="Cerrar ventana"
              >
                x
              </button>
            </div>
          </slot>
        </header>
        <section class="modal-body" id="modalDescription">
          <div class="container">
            <!-- ++++++++++ TABLA SUSCRIBCIÓN +++++++++ -->
            <div name="body">
              <h2>Listado de listas de correo a las cuales me suscribí</h2>
            </div>
            <div class="table-responsive">
              <table id="tablaBeneficios" class="table table-hover">
                <thead>
                  <tr>
                    <th v-for="col in columnas" v-bind:key="col" scope="col">
                      {{ col }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="lista in listasDeCorreoSuscriptas"
                    v-bind:key="lista.id"
                  >
                    <td>{{ lista.nombre }}</td>
                    <td>{{ lista.campo }}</td>
                    <td>
                      <div class="opciones-de-elemento">
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="desuscribirme(lista)"
                        >
                          Desuscribirme
                          <font-awesome-icon
                            class="desuscribirme"
                            :icon="Icons.CERRAR"
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- ---------- TABLA SUSCRIBCIÓN --------- -->
            <hr class="linea" />
            <!-- ++++++++++ TABLA NO SUSCRIBCIÓN +++++++++ -->
            <div name="body">
              <h2>Recibir información sobre:</h2>
            </div>
            <div class="table-responsive">
              <table id="tablaBeneficios" class="table table-hover">
                <thead>
                  <tr>
                    <th v-for="col in columnas" v-bind:key="col" scope="col">
                      {{ col }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="lista in listasDeCorreoNoSuscriptas"
                    v-bind:key="lista.id"
                  >
                    <td>{{ lista.nombre }}</td>
                    <td>{{ lista.campo }}</td>
                    <td>
                      <div class="opciones-de-elemento">
                        <button
                          type="button"
                          class="btn btn-warning"
                          @click="suscribirme(lista)"
                        >
                          Suscribirme
                          <font-awesome-icon
                            class="suscribirme"
                            :icon="Icons.ACEPTAR"
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- ---------- TABLA NO SUSCRIBCIÓN --------- -->
          </div>
          <!-- -Box cards nuevo -->
        </section>
        <footer class="modal-footer">
          <slot name="footer">
            <button
              type="button"
              class="btn-green"
              @click="close"
              aria-label="Close modal"
            >
              Salir
            </button>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";

import { environment } from "../../../environments/environment";
import { Icons as IconConstants } from "../../../constants";

export default {
  name: "modallista",
  components: {
    FontAwesomeIcon,
  },
  computed: {
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
  },
  methods: {
    suscribirme(lista) {
      this.lista = lista;
      this.idUsuario = localStorage.getItem("iduser");

      axios
        .get(environment.API_URL + "cliente/" + this.idUsuario)
        .then((response) => {
          this.usuario = response.data;
          this.suscripcion.cliente = this.usuario;
          this.suscripcion.listaCorreo = this.lista;

          axios
            .post(environment.API_URL + "suscripcionlista", this.suscripcion)
            .then(() => {
              this.suscripcion = {};
              axios
                .get(
                  environment.API_URL +
                    "suscripcionlista/listascliente/" +
                    this.idCliente
                )
                .then((response) => {
                  this.listasDeCorreoSuscriptas = response.data;
                });

              axios
                .get(
                  environment.API_URL +
                    "suscripcionlista/nocliente/" +
                    this.idCliente
                )
                .then((response) => {
                  this.listasDeCorreoNoSuscriptas = response.data;
                });
            });
        })
        .catch((error) => {
          Swal.fire(
            "Error",
            "Ocurrió un error al intentar suscribirse.",
            "error"
          );
          console.log(error);

          this.suscribiendo = false;
        });
    },
    desuscribirme(lista) {
      const idCliente = localStorage.getItem("iduser");
      this.datosSuscripcion.idLista = lista.id;
      this.datosSuscripcion.idCliente = idCliente;

      axios
        .post(
          environment.API_URL + "suscripcionlista/deleteSuscripcion",
          this.datosSuscripcion
        )
        .then(() => {
          axios
            .get(
              environment.API_URL +
                "suscripcionlista/listascliente/" +
                idCliente
            )
            .then((response) => {
              this.listasDeCorreoSuscriptas = response.data;
            });

          axios
            .get(
              environment.API_URL + "suscripcionlista/nocliente/" + idCliente
            )
            .then((response) => {
              this.listasDeCorreoNoSuscriptas = response.data;
            });
        });
    },
    close() {
      this.$emit("close");
    },
  },
  data() {
    return {
      idUsuario: "",
      usuario: {},
      suscripcion: {},
      columnas: ["Nombre", "Campo agrupador", "Acción"],
      listasDeCorreoSuscriptas: [],
      listasDeCorreoNoSuscriptas: [],
      algo: false,
      datosSuscripcion: {},
      sourceLogo: "",
      token: "",
      idCliente: "",
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.idCliente = localStorage.getItem("iduser");

    axios
      .get(
        environment.API_URL + "suscripcionlista/listascliente/" + this.idCliente
      )
      .then((response) => {
        this.listasDeCorreoSuscriptas = response.data;
      });

    axios
      .get(environment.API_URL + "suscripcionlista/nocliente/" + this.idCliente)
      .then((response) => {
        this.listasDeCorreoNoSuscriptas = response.data;
      });
  },
};
</script>

<style scoped>
.modal-backdrop {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: var(--color-moda-h);
  box-shadow: 2px 2px 20px 1px;
  /* overflow-x: auto; */
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  width: 100%;
  position: initial;
  height: 90%;
  /* left: 25%; */
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  /* border-bottom: 1px solid #eeeeee; */
  /* color: #4aae9b; */
  justify-content: space-between;
  background: var(--color-estructura-a);
}

.modal-header h5 {
  font-family: var(--fuente-din);
  color: var(--color-estructura-c);
  font-size: 5vw;
}

.modal-header .btn-close {
  margin-bottom: 50%;
  margin: 0 0 .5rem auto;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
  background: var(--color-estructura-a);
}

.modal-footer p {
  color: var(--color-estructura-c);
}

.modal-body {
  position: relative;
  padding: 20px 10px;
  overflow-y: scroll;
}

.modal-body div h2 {
  font-family: var(--fuente-din);
  font-size: 4vw;
  /* border-bottom: 2px solid var(--color-estructura-c); */
}

.btn-close {
  border: none;
  font-size: 16px;
  padding: 0px !important;
  cursor: pointer;
  font-weight: bold;
  color: var(--color-estructura-c);
  background: transparent;
  margin-bottom: 50%;
  vertical-align: none;
  bottom: 1px;
}

.btn-close:focus {
  outline: none;
}

.box-salir {
  border: 1px solid var(--color-estructura-c);
  justify-self: right;
  position: relative;
  display: block;
  background: var(--color-estructura-a);
  border-radius: 25px;
  width: 25px;
  height: 25px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.box-salir a {
  position: absolute;
  background: transparent;
  border-radius: 25px;
  width: 25px;
  height: 25px;
  right: 0;
  cursor: pointer;
}

.box-salir:hover {
  background: white;
}

.btn-close:hover {
  color: black;
  border: none;
}

.btn-green {
  color: white;
  background: var(--color-estructura-c);
  border: 1px solid var(--color-estructura-c);
  border-radius: 2px;
}

.btn-green:hover {
  color: var(--color-estructura-a);
  background: white;
  border: 1px solid white;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.table thead th,
.tabletd,
.table th {
  border: none !important;
}

.table thead tr th {
  font-size: 12px;
  font-weight: bold;
  color: white;
}

.table tbody tr td {
  font-size: 11px;
  margin: 0;
  padding: 1rem 0.75rem 0rem 0.75rem;
}

.btn-warning {
  background-color: #28a745;
  border-color: #28a745;
}

.btn-warning:hover {
  background-color: #2f9046;
  border-color: #2f9046;
}

.btn-danger,
.btn-warning {
  width: 100px;
  height: 27px;
  font-size: 9px;
  bottom: 0.5rem;
}

.btn-danger {
  font-size: 9px;
  padding-top: 8px;
}

.btn-danger svg {
  top: 1px;
  position: relative;
}

.btn-warning {
  font-size: 11px;
  padding-top: 5px;
  position: relative;
  padding-right: 15%;
}

.btn-warning svg {
  position: absolute;
  transform: translate(2px, 2px);
  font-size: 9px;
}

.linea {
  color: var(--color-estructura-c);
  border: 2px solid var(--color-estructura-c);
}

/* .hello {
} */
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  /* display: inline-block; */
  margin: 0 10px;
}
a {
  color: #42b983;
}

.shadow2 {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.shadow2:hover {
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}
.correccion {
  display: none;
}

.contenedor-info button {
  display: inline-flex;
  flex-direction: column-reverse;
  text-align: center;
  border-radius: 0 0 10px 10px;
  height: 60px;
  z-index: 100;
  width: 140px;
  padding-bottom: 7px;
  align-items: center;
}

.contenedor-info button:hover {
  border-color: rgb(40, 168, 69) !important;
  background: var(--color-estructura-c);
  text-decoration-color: currentcolor;
}

.contenedor-info button i {
  position: absolute;
  bottom: 28px;
  right: 20px;
  height: 0;
  color: black;
  z-index: 500;
  font-weight: bold;
}

.grid-contenedor-moda {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 200px auto;
  padding-top: 20px;
  background: var(--color-moda-h);
}

.box-menu-moda {
  text-align: left;
}

.box-cards-moda {
  display: grid;
  grid-template-columns: repeat(auto-fill, 150px);
  grid-template-rows: 230px;
  align-items: center;
  justify-content: center;
}

/* ************************************************************************ */
/* ******************* Media Queries ************************************** */
/* ************************************************************************ */

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .btn-danger {
    width: 120px;
    font-size: 12px;
    padding-top: 4px;
  }

  .btn-warning {
    width: 120px;
    font-size: 13px;
    padding-top: 3px;
    padding-right: 14%;
  }

  .btn-warning svg {
    position: absolute;
    transform: translate(2px, 4px);
    font-size: 10px;
  }

  .table tbody tr td {
    font-size: 13px;
  }

  .table thead tr th {
    font-size: 14px;
    font-weight: bold;
  }

  .modal {
    width: 80%;
    height: 90%;
  }

  .modal-header h5 {
    font-size: 25px;
  }

  .modal-body div h2 {
    font-size: 20px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .modal {
    width: 65%;
    height: 90%;
  }

  .btn-danger,
  .btn-warning {
    height: 32px;
  }

  .btn-danger {
    padding-top: 6px;
  }

  .btn-warning {
    padding-top: 5px;
    padding-right: 14%;
  }

  .btn-warning svg {
    transform: translate(5px, 4px);
    font-size: 11px;
  }

  .modal-header h5 {
    font-size: 30px;
  }

  .modal-body div h2 {
    font-size: 25px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .btn-danger,
  .btn-warning {
    height: auto;
    width: 200px;
    font-size: 16px;
  }

  .btn-warning {
    padding-right: 3vw;
    padding-top: 5px;
  }

  .btn-warning svg {
    transform: translate(8px, 4px);
    font-size: 14px;
  }

  .table tbody tr td {
    font-size: 16px;
  }

  .table thead tr th {
    font-size: 17px;
    font-weight: bold;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>
